import {
    INVALIDATE_MARCAS,
    ERROR_MARCAS,
    RECEIVE_MARCAS,
    REQUEST_MARCAS,
    RESET_MARCAS,
    ERROR_MARCA,
    RECEIVE_MARCA,
    REQUEST_MARCA,
    UPDATE_MARCA,
    REQUEST_UPDATE_MARCA,
    SUCCESS_UPDATE_MARCA,
    ERROR_UPDATE_MARCA,
    RESET_UPDATE_MARCA,
    REQUEST_UPDATE_MARCAS,
    SUCCESS_UPDATE_MARCAS,
    ERROR_UPDATE_MARCAS,
    RESET_UPDATE_MARCAS,
    CREATE_MARCA,
    ERROR_CREATE_MARCA,
    REQUEST_CREATE_MARCA,
    RESET_CREATE_MARCA,
    SUCCESS_CREATE_MARCA,
    REQUEST_CREATE_MARCAS,
    SUCCESS_CREATE_MARCAS,
    ERROR_CREATE_MARCAS,
    RESET_CREATE_MARCAS,
    DELETE_MARCA,
    DELETE_CREATE_MARCA,
    DELETE_UPDATE_MARCA,
    REQUEST_DELETE_MARCA,
    SUCCESS_DELETE_MARCA,
    ERROR_DELETE_MARCA,
    RESET_DELETE_MARCA,
    REQUEST_PRINT_MARCA,
    SUCCESS_PRINT_MARCA,
    ERROR_PRINT_MARCA,
    RESET_PRINT_MARCA
} from '../actions/MarcaActions';


import {combineReducers} from 'redux';
import {LOGOUT_SUCCESS} from "../actions/AuthActions";

import merge from "lodash/merge";
import mergeWith from "lodash/mergeWith";
import union from "lodash/union";
import clone from "lodash/clone";
import difference from "lodash/difference";
import omit from "lodash/omit";
import pickBy from "lodash/pickBy";
import filter from "lodash/filter";

function getInitialStateById() {
    return {
        isFetching: false,
        didInvalidate: true,
        marcas: {},
    }
}

function marcasById(state = getInitialStateById(), action) {
    switch (action.type) {
        case INVALIDATE_MARCAS:
            return Object.assign({}, state, {
                didInvalidate: true
            });
        case REQUEST_MARCAS:
            return Object.assign({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case ERROR_MARCAS:
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: true,
                error: action.error
            });
        case RESET_MARCAS:
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: true,
                error: null,
                lastUpdated: null,
                marcas: {}
            });
        case RECEIVE_MARCAS:
            let dato = action.marcas.entities.marcas;
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: false,
                marcas: merge({}, state.marcas, dato),
                lastUpdated: action.receivedAt
            });
        case REQUEST_MARCA:
            return Object.assign({}, state, {
                isFetching: true,
            });
        case ERROR_MARCA:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.error
            });
        case RECEIVE_MARCA:
            let datoMarca = action.marca.entities.marcas;
            return Object.assign({}, state, {
                marcas: merge({}, state.marcas, datoMarca),
                isFetching: false,
            });
        
        case SUCCESS_DELETE_MARCA:
            let datoMarcaEliminado = action.marca.entities.marcas;
            return Object.assign({}, state, {
                marcas: mergeWith(clone(datoMarcaEliminado), state.marcas, (objValue, srcValue) => {return objValue;})
            });
        case SUCCESS_CREATE_MARCA:
            let datoMarcaCreado = action.marca.entities.marcas;
            return Object.assign({}, state, {
                marcas: mergeWith(clone(datoMarcaCreado), state.marcas, (objValue, srcValue) => {return objValue;})
            });
        case SUCCESS_CREATE_MARCAS:
            let datosMarcaCreado = action.marcas.entities.marcas;
                return Object.assign({}, state, {
                    marcas: mergeWith(clone(datosMarcaCreado), state.marcas, (objValue, srcValue) => {return objValue;})
                });
        case SUCCESS_UPDATE_MARCA:
            let datoMarcaActualizado = action.marca.entities.marcas;
            return Object.assign({}, state, {
                marcas: mergeWith(clone(datoMarcaActualizado), state.marcas, (objValue, srcValue) => {return objValue;})
            });
         case SUCCESS_UPDATE_MARCAS:
            let datosMarcaActualizado = action.marcas.entities.marcas;
                return Object.assign({}, state, {
                    marcas: mergeWith(clone(datosMarcaActualizado), state.marcas, (objValue, srcValue) => {return objValue;})
                });

            

            

        case LOGOUT_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: true,
                error: null,
                marcas: {}
            });
        default:
            return state
    }
}


function allMarcas(state = [], action) {
    switch (action.type) {
        case RECEIVE_MARCAS:
            return action.marcas.result && action.marcas.result.marcas ? union(action.marcas.result.marcas, state) : (action.marcas.result ? action.marcas.result : state) ;
        case RECEIVE_MARCA:
                return action.marca.result ? union([action.marca.result], state) : state;
        
        case SUCCESS_CREATE_MARCA:
                   let datoMarcaSCreate = action.marca.entities.marcas;
                   let idNuevoSCreate = null;
                   if (Object.values(datoMarcaSCreate).length > 0)
                       idNuevoSCreate = Object.values(datoMarcaSCreate)[0] && Object.values(datoMarcaSCreate)[0].id ? Object.values(datoMarcaSCreate)[0].id : null;
                   if (idNuevoSCreate)
                       return union(state, [idNuevoSCreate]);
                   else
                       return state;
       case SUCCESS_CREATE_MARCAS:
                   let marcasCreate = action.marcas.entities && action.marcas.entities.marcas ? action.marcas.entities.marcas : null;
                   return marcasCreate ?
                       union(state, Object.values(marcasCreate).map((marcas) => {
                           return marcas.id
                       })) : state;
        case RESET_MARCAS:
            return [];

            

        case LOGOUT_SUCCESS:
            return [];
        default:
            return state
    }
}

function totalMarcas(state = null, action) {
    switch (action.type) {
        case RECEIVE_MARCAS:
            return action.marcas && action.marcas.result.total ? action.marcas.result.total : 0;
        case RESET_MARCAS:
            return null;
        case LOGOUT_SUCCESS:
            return null;
        default:
            return state
    }
}

function update(state = {
    isUpdating: false,
    activo: {},
    activos: []
}, action) {
    switch (action.type) {
        case RECEIVE_MARCA:
            let dato = action.marca.entities.marcas;
            let marca = dato && Object.keys(dato).length > 0 ? dato[Object.keys(dato)[0]] : {};
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: false,
                activo: marca ? marca : [],
                lastUpdated: action.receivedAt
            });
        case UPDATE_MARCA:
            let idsUpdate = [];
            Object.values(action.marca).map((marcaUpdate) => {
                if (marcaUpdate && marcaUpdate.id)
                    idsUpdate.push(marcaUpdate.id);
            });
            return merge({}, state, {
                activo: action.marca,
                activos: idsUpdate.length > 0 ? union(state.activos, idsUpdate) : state.activos,
                error: ""
            });
        case REQUEST_UPDATE_MARCA:
            return Object.assign({}, state, {
                isUpdating: true,
                error: null
            });
        case SUCCESS_UPDATE_MARCA:
            let datoMarcaActualizado = {};
            if (Object.values(action.marca.entities.marcas).length > 0)
                datoMarcaActualizado = Object.values(action.marca.entities.marcas)[0];
            return Object.assign({}, state, {
                isUpdating: false,
                lastUpdated: action.receivedAt,
                error: null,
                activo: datoMarcaActualizado
            });
        case ERROR_UPDATE_MARCA:
            return Object.assign({}, state, {
                isUpdating: false,
                error: action.error
            });
            case REQUEST_UPDATE_MARCAS:
                return Object.assign({}, state, {
                    isUpdating: true,
                    error: null
                });
            case SUCCESS_UPDATE_MARCAS:
                return Object.assign({}, state, {
                    isUpdating: false,
                    lastUpdated: action.receivedAt,
                    error: null,
                    activo: {},
                    activos: []
                });
            case ERROR_UPDATE_MARCAS:
                return Object.assign({}, state, {
                    isUpdating: false,
                    error: action.error
                });
        case RESET_UPDATE_MARCA:
            return Object.assign({}, state, {
                isUpdating: false,
                activo: {},
                activos: [],
                error: ""
            });

           

           

        case DELETE_MARCA:
            let datoMarcaDelete = action.marca;
            let idsDelete = [];
           Object.values(action.marca).map((marcaDelete) => {
               if (marcaDelete && marcaDelete.id)
                   idsDelete.push(marcaDelete.id);
           });
            if (idsDelete.length > 0)
                return Object.assign({}, state, {
                    activo: omit(clone(state.activo), Object.keys(datoMarcaDelete)),
                    activos: difference(clone(state.activos), idsDelete)
                });
            else
               return state;
           case DELETE_UPDATE_MARCA:
                       let datoMarcaDeleteUpdate = action.marca;
                       let idsDeleteUpdate = [];
                      Object.values(action.marca).map((marcaDelete) => {
                          if (marcaDelete && marcaDelete.id)
                              idsDeleteUpdate.push(marcaDelete.id);
                      });
                       if (idsDeleteUpdate.length > 0)
                           return Object.assign({}, state, {
                               activo: omit(clone(state.activo), Object.keys(datoMarcaDeleteUpdate)),
                               activos: difference(clone(state.activos), idsDeleteUpdate)
                           });
                       else
                          return state;
        case SUCCESS_DELETE_MARCA:
                    let datoMarcaDeleted = {};
                    if (Object.values(action.marca.entities.marcas).length > 0)
                        datoMarcaDeleted = Object.values(action.marca.entities.marcas)[0];
                    return Object.assign({}, state, {
                        isUpdating: false,
                        lastUpdated: action.receivedAt,
                        error: null,
                        activo: datoMarcaDeleted
                    });
        case LOGOUT_SUCCESS:
            return Object.assign({}, state, {
                isUpdating: false,
                activo: {},
                error: ""
            });
        default:
            return state
    }
}

function create(state = {
    isCreating: false,
    nuevo: {},
    nuevos: [],
    error: ""
}, action) {
    switch (action.type) {
        case CREATE_MARCA:
             let idsCreate = [];
             Object.values(action.marca).map((marcaCreate) => {
                 if (marcaCreate && marcaCreate.id)
                     idsCreate.push(marcaCreate.id);
             });
            return merge({}, state, {
                isCreating: false,
                nuevo: action.marca,
                nuevos: idsCreate.length > 0 ? union(state.nuevos, idsCreate) : state.nuevos,
                error: null,
            });
        case REQUEST_CREATE_MARCA:
            return Object.assign({}, state, {
                isCreating: true,
                error: null,
            });
        case SUCCESS_CREATE_MARCA:
            let datoMarcaNuevo = {};
            if (Object.values(action.marca.entities.marcas).length > 0)
                datoMarcaNuevo = Object.values(action.marca.entities.marcas)[0];
            return Object.assign({}, state, {
                isCreating: false,
                lastUpdated: action.receivedAt,
                error: null,
                nuevo: datoMarcaNuevo,
                nuevos: []
            });
        case ERROR_CREATE_MARCA:
            return Object.assign({}, state, {
                isCreating: false,
                error: action.error
            });
        case REQUEST_CREATE_MARCAS:
            return Object.assign({}, state, {
                isCreating: true,
                error: null
            });
        case SUCCESS_CREATE_MARCAS:
            return Object.assign({}, state, {
                isCreating: false,
                lastUpdated: action.receivedAt,
                error: null,
                nuevo: {},
                nuevos: []
            });
        case ERROR_CREATE_MARCAS:
            return Object.assign({}, state, {
                isCreating: false,
                error: action.error
            });
        case RESET_CREATE_MARCA:
            return Object.assign({}, state, {
                isCreating: false,
                error: null,
                nuevo: {},
                nuevos: []
            });

             

             
        case DELETE_MARCA:
           let datoMarcaDelete = action.marca;
           let idsDelete = [];
           Object.values(action.marca).map((marcaDelete) => {
               if (marcaDelete && marcaDelete.id)
                   idsDelete.push(marcaDelete.id);
           });
            if (idsDelete.length > 0)
                return Object.assign({}, state, {
                    nuevo: omit(clone(state.nuevo), Object.keys(datoMarcaDelete)),
                    nuevos: difference(clone(state.nuevos), idsDelete)
                });
            else
               return state;
       case DELETE_CREATE_MARCA:
                  let datoMarcaDeleteCreate = action.marca;
                  let idsDeleteCreate = [];
                  Object.values(action.marca).map((marcaDelete) => {
                      if (marcaDelete && marcaDelete.id)
                          idsDeleteCreate.push(marcaDelete.id);
                  });
                   if (idsDeleteCreate.length > 0)
                       return Object.assign({}, state, {
                           nuevo: omit(clone(state.nuevo), Object.keys(datoMarcaDeleteCreate)),
                           nuevos: difference(clone(state.nuevos), idsDeleteCreate)
                       });
                   else
                      return state;
        case LOGOUT_SUCCESS:
            return Object.assign({}, state, {
                isCreating: false,
                error: null,
                nuevo: {}
            });
        default:
            return state
    }
}

function deleter(state = {
    isDeleting: false,
    eliminado: {},
    error: ""
}, action) {
    switch (action.type) {
        case DELETE_MARCA:
            return merge({}, state, {
                isDeleting: false,
                eliminado: action.marca,
                error: null,
            });
        case REQUEST_DELETE_MARCA:
            return Object.assign({}, state, {
                isDeleting: true,
                error: null,
            });
        case SUCCESS_DELETE_MARCA:
            return Object.assign({}, state, {
                isDeleting: false,
                error: null,
            });
        case ERROR_DELETE_MARCA:
            return Object.assign({}, state, {
                isDeleting: false,
                error: action.error
            });
        case RESET_DELETE_MARCA:
            return Object.assign({}, state, {
                isDeleting: false,
                error: null,
                eliminado: {}
            });
             
        case LOGOUT_SUCCESS:
            return Object.assign({}, state, {
                isDeleting: false,
                error: null,
                eliminado: {}
            });
        default:
            return state
    }
}

function print(state = {
    isPrinting: false,
    error: ""
}, action) {
    switch (action.type) {
        case REQUEST_PRINT_MARCA:
            return Object.assign({}, state, {
                isPrinting: true,
                error: null,
            });
        case SUCCESS_PRINT_MARCA:
            return Object.assign({}, state, {
                isPrinting: false,
                lastUpdated: action.receivedAt,
                error: null,
            });
        case ERROR_PRINT_MARCA:
            return Object.assign({}, state, {
                isPrinting: false,
                error: action.error
            });
        case LOGOUT_SUCCESS:
            return Object.assign({}, state, {
                isPrinting: false,
                error: null,
            });
        default:
            return state
    }
}

const marcas = combineReducers({
    byId: marcasById,
    allIds: allMarcas,
    update: update,
    create: create,
    totalMarcas: totalMarcas,
    delete: deleter,
    print: print
});

export default marcas;